// @generated
// This file is automatically generated by Kanel. Do not modify manually.

import { z } from 'zod';

/** Represents the enum public.analytics_event_name */
enum AnalyticsEventName {
  page_view = 'page_view',
  page_leave = 'page_leave',
  page_scroll = 'page_scroll',
  link_click = 'link_click',
  subscribe_to_newsletter = 'subscribe_to_newsletter',
  unsubscribe_to_newsletter = 'unsubscribe_to_newsletter',
};

export default AnalyticsEventName;

/** Zod schema for analytics_event_name */
export const analyticsEventName = z.enum([
  'page_view',
  'page_leave',
  'page_scroll',
  'link_click',
  'subscribe_to_newsletter',
  'unsubscribe_to_newsletter',
]);
